<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Log')"
    width="750px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'TuckOrderLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'MODIFIED_DATE',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'MODIFIED_NAME',
          width: 100
        },
        {
          headerName: this.$t('Message.OperationCategory'),
          field: 'MODIFIED_TYPE',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.operationContent'),
          field: 'CONTENT',
          width: 320
        }
      ],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  }
}
</script>

<style>
</style>
